module.exports = __webpack_public_path__ + "media/images/heart-outline-b69596035b4c498cbe89469c0273b4ab.svg";